// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"ffa32c24","848":"f92aef60"}[chunkId] + ".chunk.js";
};